import { useContext } from 'react';
import * as R from 'ramda';

import { numberToLocaleString } from '@atom/utilities/currencyUtility';
import timeUtilities from '@atom/utilities/timeUtilities';

import {
  getDefaultConversionUnit,
  toConvertedRate,
} from '../costTab/costTabUtilities';
import InventoryDetailContext from '../InventoryDetailContext';

import HeaderField from './HeaderField';

import classes from './header.module.css';

const HeaderFields = () => {
  const { asset, conversionUnits } = useContext(InventoryDetailContext);

  const inventoryAssetName = asset.name || '-';
  const assetType = asset.assetType || '-';
  const address = asset.address || '-';
  const breadcrumbs = asset.categories || [];

  const rate = R.pathOr('', ['budget', 'rate'], asset);
  const baseCost = `${numberToLocaleString(rate)}/${R.pathOr(
    '',
    ['budget', 'unit'],
    asset,
  )}`;

  // always the default unit; the Cost tab's unit selector doesn't affect it
  const defaultConversionUnit = getDefaultConversionUnit(conversionUnits);

  const cost =
    defaultConversionUnit && defaultConversionUnit.active
      ? `${baseCost} (${numberToLocaleString(
          toConvertedRate(rate, defaultConversionUnit),
        )}/${defaultConversionUnit.unit})`
      : baseCost;

  const breadcrumbString = breadcrumbs.map(folder => folder.name).join(' > ');

  const hasLocation = !R.isNil(asset.locationType);
  const hasCost = !!asset.isMaterial;
  const lastUpdated = timeUtilities.getUtcDisplayDate(asset.updatedDate);

  return (
    <div className={classes.headerGrid}>
      <HeaderField label="Inventory Name:" value={inventoryAssetName} />
      <HeaderField label="Type:" value={assetType} />
      <HeaderField label="Inventory Folder:" value={breadcrumbString} />
      <HeaderField label="Last Updated:" value={lastUpdated} />
      {hasLocation && <HeaderField label="Location:" value={address} />}
      {hasCost && (
        <HeaderField label="Cost:" value={cost}>
          <span className={classes.costText}>{cost}</span>
        </HeaderField>
      )}
    </div>
  );
};

export default HeaderFields;
